<template>
  <div class="text-center">
    <div v-if="error" class="mt-8 mb-32">
      <p class="error-message">
        Error occurred, please refresh page to start over.
      </p>
      <div class="refresh-search" role="button" @click="refreshSearch">
        <svg class="icon icon-refresh" aria-hidden="true" focusable="false">
          <use xlink:href="#icon-refresh" />
        </svg>
        Refresh search
      </div>
    </div>

    <div
      v-if="!error && apiCallMade && results.length === 0"
      class="mt-8 mb-32"
    >
      <p class="no-results">
        {{ noResultsMessage }}
      </p>
      <div class="refresh-search">
        <a
          :href="
            noResultsOpenChat ? 'javascript:void(0)' : `/${noResultsRedirect}`
          "
          :class="
            `link-download-image link-download-image--black justify-center font-bold ${
              noResultsOpenChat ? 'js-show-web-chat' : ''
            }`
          "
          :data-analytics_string="
            noResultsOpenChat ? 'INP|No Results|Open Chat' : null
          "
        >
          {{ noResultsRedirectText }}
          <svg class="icon icon-cta ml-4" aria-hidden="true" focusable="false">
            <use xlink:href="#icon-cta" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '../shared/event-bus';

export default {
  props: [
    'results',
    'apiCallMade',
    'error',
    'noResultsMessage',
    'noResultsRedirect',
    'noResultsRedirectText',
    'noResultsOpenChat',
  ],
  methods: {
    refreshSearch() {
      eventBus.refreshSearch();
    },
  },
};
</script>
